import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../../store/actions/index';
import { useParams } from "react-router";
import ProjectOfferPositions from './ProjectOfferPositions';
import * as modalTypes from '../Modals/modalTypes';
import PsDropdown from '../UI/PsDropdown';
import useCustomTranslation from '../../hooks/useCustomTranslation';
import {Link } from "react-router-dom";
import { ROUTES } from '../../routes';
import { useTranslation } from 'react-i18next';

import BackgroundActive from '../../images/icon_revit.png';
import Navigation from './Navigation';
import Aux from '../../hoc/Aux';


const ProjectCalculation = (props) => {
  return (
    <div>

      <ProjectOfferPositions
        projectId={props.projectId}
      />
    </div>
  )
}

export default ProjectCalculation;


// WEBPACK FOOTER //
// ./src/components/Project/ProjectCalculation.js